<template>
  <!-- Popup Deposit -->
  <el-dialog :title="$t('TEXT_SUCCESS')" :visible.sync="isShowDepositSuccessForm" class="deposit-form">
    <div class="popup-inner">
      <div class="item icon-wrapper">
        <i class="el-icon-circle-check"></i>
      </div>
      <div class="item">
        <div class="text-break-word bold">{{ $t('TEXT_DEPOSIT_SUCCESS', { amount: modalData.amount, symbol: modalData.currency }) }}</div>
        <p>{{ $t('TEXT_CLICK_TO_VIEW_TRANSACTION') }}
          <a class="active" :href="`${configs.bscScanUrl}${modalData.hash}`" target="_blank">{{ $t('BTN_VIEW_TRANSACTION') }}</a>
        </p>
      </div>
      <div class="item item-submit">
        <a class="btn btn-submit" @click="closeModal">{{ $t('BTN_CLOSE') }}</a>
      </div>
    </div>
  </el-dialog>
  <!-- End Popup Deposit -->
</template>

<script>
export default {
  computed: {
    isShowDepositSuccessForm: {
      get () {
        return this.$store.getters.isShowDepositSuccessForm
      },
      set () {
        this.$store.dispatch('toggleDepositSuccessForm')
      }
    },
    modalData () {
      return this.$store.getters.modalData
    },
    configs () {
      return this.$store.getters.configs
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('toggleDepositSuccessForm')
    }
  }
}
</script>
